import ApiService from "@/utils/request";
export const commonApi = {
    // 统计子系统资产数据
    statSubsystemData: () => ApiService.get("/asset/count/statSubsystemData/0"),
    // 公司树获取
    companyTree: () => ApiService.get("/am/common/companyTree"),
};
